import React, {useContext} from "react";
import {LanguageContext} from "../../App";
import classes from "../../styles/component_styles/services.module.scss";
import image from "../../images/services/Doors.jpg";
import {BsDoorOpenFill} from "react-icons/bs";
import {Col, Container, Row} from "react-bootstrap";
import {Helmet} from "react-helmet";

function DoorsPage() {

    const languageContext = useContext(LanguageContext);

    return(
        <>

            <Helmet>
                <title>Doors Installation Services in Charlotte NC</title>
                <meta
                    name="description"
                    content="Explore premier doors installation services in Charlotte NC. From entryways to interior doors, our expert team ensures quality installations for your home."
                />
            </Helmet>

            <div className={classes.start_image}>
                <h1 className={classes.start_message}><BsDoorOpenFill className={classes.servicesIcon}/> {languageContext.services.DoorsPage.title}</h1>
                <p className={classes.darkText}>{languageContext.services.DoorsPage.description}</p>
            </div>

            <Container>
                <Row>
                    <Col xl={8} lg={8} md={6} sm={12} xs={12}>
                        <p className={classes.description}>
                            {languageContext.services.DoorsPage.text1}
                            <br/><br/>
                            <span>{languageContext.services.DoorsPage.text2}</span>
                            <br/>
                            {languageContext.services.DoorsPage.text3}
                            <br/><br/>
                            <span>{languageContext.services.DoorsPage.text4}</span>
                            <br/>
                            {languageContext.services.DoorsPage.text5}
                            <br/><br/>
                            <span>{languageContext.services.DoorsPage.text6}</span>
                            <br/>
                            {languageContext.services.DoorsPage.text7}
                            <br/><br/>
                            <span>{languageContext.services.DoorsPage.text8}</span>
                            <br/>
                            {languageContext.services.DoorsPage.text9}
                        </p>
                    </Col>
                    <Col xl={4} lg={4} md={6} sm={12} xs={12}>
                        <img src={image} className={classes.image}/>
                    </Col>
                </Row>
            </Container>
        </>
    );

}

export default DoorsPage;